import { Checkbox, Label } from '.'

type Option = {
	id: string
	label: string
}

type CheckboxGroupProps = {
	options: Option[]
	selected: string[]
	setSelected: React.Dispatch<React.SetStateAction<string[]>>
	label?: string
}

export function CheckboxGroup({ options, selected = [], setSelected, label }: CheckboxGroupProps) {
	const handleChange = (optionId: string) => {
		const newSelected = selected.includes(optionId) ? selected.filter(id => id !== optionId) : [...selected, optionId]

		setSelected(newSelected)
	}

	return (
		<div className='space-y-4'>
			{label && <Label className='text-base'>{label}</Label>}
			<div className='flex flex-col gap-3'>
				{options.map(option => (
					<div key={option.id} className='flex items-center space-x-2'>
						<Checkbox
							id={option.id}
							checked={selected.includes(option.id)}
							onCheckedChange={() => handleChange(option.id)}
						/>
						<Label htmlFor={option.id} className='font-normal'>
							{option.label}
						</Label>
					</div>
				))}
			</div>
		</div>
	)
}
